export default __webpack_public_path__ + "static/media/University_of_New_Hampshire.5a00e317.png";